import { useTranslation } from 'react-i18next';
import { DeleteOutlined, FilterOutlined } from "@ant-design/icons";
import { Button, Col, DatePicker, Form, Row, Select, Typography } from "antd";
import { viLocale as locale } from "../../../../utils/pickerType";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getEnrollClass } from "../../../../service/test-schedule";
import { filterOption } from "../../../../utils/functionUltils";
import useKeyword from "../../../../hooks/useKeyword";

interface FormFilterProps {
  handleCloseFilter: () => void
  showFilter: boolean;
  setFilterData: (values: any) => void;
  dataOptions?: any;
}


const FormFilter = (props: FormFilterProps) => {
  const { t } = useTranslation();
  const { showFilter, setFilterData } = props
  const [form] = Form.useForm();
  const { Title } = Typography;
  const { RangePicker } = DatePicker;
  const { courseId } = useParams()
  const [classList, setClassList] = useState<any>([])
  const blockId = useKeyword("blockId")
  const handleFinish = (values: any) => {
    setFilterData(values)
  };

  useEffect(() => {
    const fetchEnrollClass = async () => {
      try {
        const payload = {
          page: 1, size: null,
          courseId: courseId,
          blockId: blockId
        }
        const res = await getEnrollClass(payload)
        setClassList(res?.data.data.content.map((it: any) => {
          return {
            ...it,
            value: it.id,
            label: it.name,
          }
        }))
      } catch (error) {

      }
    }
    fetchEnrollClass()
  }, [])

  return (
    <div className={`wrapper-filter ${showFilter ? "open" : ""}`}>
      <Form form={form} onFinish={handleFinish} layout="vertical">
        <Row gutter={[16, 16]}>

          <Col xs={24} sm={12} md={4}>
            <Title level={5}>{t("Lớp", "Lớp")}</Title>
            <Form.Item name="class" className="mb-0">
              <Select
                showSearch
                placeholder={t("Chọn lớp", "Chọn lớp")}
                filterOption={filterOption}
                options={classList}
                mode="multiple"

              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={4}>
            <Title level={5}>{t("Trạng thái", "Trạng thái")}</Title>
            <Form.Item name="status" className="mb-0">
              <Select placeholder={t("Trạng thái", "Trạng thái")}>
                <Select.Option value={0}>{t("Chưa diễn ra", "Chưa diễn ra")}</Select.Option>
                <Select.Option value={1}>{t("Đang diễn ra", "Đang diễn ra")}</Select.Option>
                <Select.Option value={2}>{t("Đã kết thúc", "Đã kết thúc")}</Select.Option>

              </Select>
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <Title level={5}>{t("Thời gian tổ chức", "Thời gian tổ chức")}</Title>
            <Form.Item name="timeCreated" className="mb-0"
            >
              <RangePicker
                format={"YYYY-MM-DD HH:mm"}
                locale={locale}
                showTime
                placeholder={[t("Bắt đầu", "Bắt đầu"), t("Kết thúc", "Kết thúc")]}

              />
            </Form.Item>
          </Col>
          <Col
            xl={{ span: 6 }}
            md={{ span: 6 }}
            sm={{ span: 24 }}
            xs={{ span: 24 }}
            style={{ display: "flex", alignItems: "flex-end" }}
          >
            <div className="group-btn--filter">
              <Button
                className="btn btn-primary search-btn"
                onClick={() => form.submit()}
              >
                <FilterOutlined />
                <Typography.Text>{t("Lọc", "Lọc")}</Typography.Text>
              </Button>
              <Button
                className="btn btn-outlined clear-filter-btn"
                onClick={() => {
                  form.resetFields();
                  setFilterData({});
                }}
              >
                <DeleteOutlined />
                <Typography.Text>{t("Xóa bộ lọc", "Xóa bộ lọc")}</Typography.Text>
              </Button>
            </div>
          </Col>
        </Row>

      </Form>
    </div>
  );
};

export default FormFilter;
